/**
 * Returns a class name based on the provided variant and suffix.
 * If the variant is not found, it falls back to a specified fallback class.
 *
 * @param {Record<string, string | undefined>} classes - An object mapping class names.
 * @param {string | undefined} variant - The variant to look for.
 * @param {string} suffix - The suffix to append to the variant.
 * @param {string} fallback - The fallback class name if the variant is not found.
 * @returns {string} The class name corresponding to the variant and suffix, or the fallback class.
 */
export default function getVariantClass(
  classes: Record<string, string | undefined>,
  variant: string | undefined,
  suffix: string,
  fallback?: string | undefined
): string {
  if (variant && suffix) {
    const variantClass = classes[`${variant}${suffix}`];
    if (variantClass) {
      return variantClass;
    }
  }
  if (fallback && classes[fallback]) {
    return classes[fallback];
  }
  return '';
}
